var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-info"},[(_vm.iconName)?_c('cp-icon',{staticClass:"card-info__icon",attrs:{"path":`/icons/${_vm.iconName}.svg`}}):_vm._e(),_c('p',{staticClass:"card-info__text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }